import { dashboardApi } from '@/store/api/base/api.base';
import type { TypePushCalendar } from '@/lib/push/push.calendar.prefs';

type TypePushLevel = 'all' | 'important' | 'none';

type TypePushDevice = {
    id: string;
    label: string;
    platform: string;
    service: string;
    level: TypePushLevel;
    preview: boolean;
    calendar: TypePushCalendar;
    createdAt: string;
    lastSuccessAt: string | null;
    fingerprint: string;
};

type TypePushState = { enabled: boolean; publicKey: string; devices: TypePushDevice[] };

const TAG = 'PushDevices' as const;

export const pushApi = dashboardApi.enhanceEndpoints({ addTagTypes: [TAG] }).injectEndpoints({
    endpoints: (build) => ({
        readPush: build.query<TypePushState, void>({
            query: () => ({ url: '/notifications/push' }),
            providesTags: [TAG],
            keepUnusedDataFor: 60,
        }),
        savePushDevice: build.mutation<TypePushDevice, { endpoint: string; p256dh: string; auth: string; label: string; platform: string; level: TypePushLevel; preview: boolean; calendar: TypePushCalendar }>({
            query: (data) => ({ url: '/notifications/push/subscriptions', method: 'post', data }),
            invalidatesTags: [TAG],
        }),
        removePushDevice: build.mutation<{ id: string }, string>({
            query: (id) => ({ url: `/notifications/push/subscriptions/${encodeURIComponent(id)}`, method: 'delete' }),
            invalidatesTags: [TAG],
        }),
        testPush: build.mutation<{ sent: number; failed: number }, { deviceId: string }>({
            query: (data) => ({ url: '/notifications/push/test', method: 'post', data }),
            invalidatesTags: [TAG],
        }),
    }),
});

export const { useReadPushQuery, useSavePushDeviceMutation, useRemovePushDeviceMutation, useTestPushMutation } = pushApi;

export default pushApi;
